import { getValue } from '@/libs/functions/getValue'
import { getStorage, setStorage } from '@/libs/functions/onStorage'
import { getLastestNoticeList } from '@/libs/services'
import { useEffect, useState } from 'react'

let hasReadNoticeHashs = getStorage('hasReadNoticeHashs') || []

function updateHashMapToStorage(newHashMap: string[]) {
  setStorage('hasReadNoticeHashs', newHashMap)
}

export interface NoticeListResp {
  /**
   * cn.com.dragonpass.business.saas.member.pojo.notice.resp.NoticeListResp.NoticeDTO
   */
  popupOrPosterNotice: NoticeDTO | null
  /**
   * cn.com.dragonpass.business.saas.member.pojo.notice.resp.NoticeListResp.NoticeDTO
   */
  rollNotice: NoticeDTO | null
}

/**
 * cn.com.dragonpass.business.saas.member.pojo.notice.resp.NoticeListResp.NoticeDTO
 *
 * NoticeDTO
 */
export interface NoticeDTO {
  /**
   * 内容
   */
  content?: string
  /**
   * 内容MD5
   */
  contentMd5?: string
  /**
   * 跳转地址
   */
  jumpUrl?: string
  /**
   * 名称
   */
  name?: string
  /**
   * 弹窗次数
   */
  popupCount?: string
  /**
   * 标题
   */
  title?: string
  /**
   * 类型
   */
  type: 'poster' | 'popup'
  /**
   * 类型
   */
  typeName?: string

  openReadCountdown: boolean | null
  countdownSecond: number | null
}

function getDefaultNoticeInfo(): {
  popupOrPosterNotice: null
  rollNotice: null
} {
  return {
    rollNotice: null,
    popupOrPosterNotice: null,
  }
}

// 公告
export default function useMoreNotice() {
  const [sectionCode, setSectionCode] = useState('')
  const [noticeVisible, setNoticeVisible] = useState(false)
  const [noticeInfo, setNoticeInfo] = useState<NoticeListResp>(
    getDefaultNoticeInfo(),
  )
  const [noticeRollVisible, setNoticeRollVisible] = useState(false)
  const [noticePopupVisible, setNoticePopupVisible] = useState(false)

  useEffect(() => {
    hasReadNoticeHashs = getStorage('hasReadNoticeHashs') || []
  }, [])

  useEffect(() => {
    if (!sectionCode) return
    getLastestNoticeList<NoticeListResp>({ sectionCode }).then((res) => {
      console.log('notice res:', res)
      const { rollNotice, popupOrPosterNotice } = res

      if (!res) {
        // setNoticeVisible(false)
        setNoticeRollVisible(false)
        setNoticePopupVisible(false)
        setNoticeInfo(getDefaultNoticeInfo())
        return
      }

      setNoticeInfo(res)
      // 跑马灯无须标记缓存
      if (rollNotice) {
        setNoticeRollVisible(true)
      }

      if (popupOrPosterNotice) {
        if (popupOrPosterNotice.contentMd5) {
          // 弹窗：检查是否命中标记缓存
          if (
            hasReadNoticeHashs.includes(popupOrPosterNotice.contentMd5) &&
            popupOrPosterNotice.popupCount === 'once'
          ) {
            setNoticePopupVisible(false)
          } else {
            setNoticePopupVisible(true)
          }
        }
      }
    })
  }, [sectionCode])

  return {
    setData: (sectionCode: string) => {
      setSectionCode(sectionCode)
    },
    // visible: noticeVisible,
    noticeRollVisible,
    noticePopupVisible,
    noticeInfo,
    onReadPopupNotice(contentMd5: string) {
      if (
        !hasReadNoticeHashs.includes(contentMd5) &&
        noticeInfo.popupOrPosterNotice?.popupCount === 'once'
      ) {
        hasReadNoticeHashs.push(contentMd5)
        updateHashMapToStorage(hasReadNoticeHashs)
        // setNoticeVisible(false)
        setNoticePopupVisible(false)
      }
    },
  }
}
